// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import GlobalSponsorStrip from "@/components/GlobalSponsorStrip";
import "./Footer.css";
import { Linkedin, Instagram, Facebook } from "lucide-react";
import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="siteFooter">
      <GlobalSponsorStrip variant="footer" />
      <div className="container-x footerInner">
        {/* Brand column */}
        <div className="footerBrandCol">
          <div className="footerLogoRow">
            <div className="footerLogoMark" />
            <span className="footerLogoText">vmeetio</span>
          </div>
          <p className="footerTagline">
            A members-led platform for hybrid events, curated tables and trusted
            circles. Built for conversations that travel beyond the room.
          </p>
          <div className="flex items-center gap-4 mt-6">
                      <a
                        href="https://www.linkedin.com/in/vmeetio-est-700015413/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        className="text-white/50 hover:text-[#C6A87C] transition-colors"
                      >
                        <Linkedin size={20} />
                      </a>
          
                      <a
                        href="https://www.tiktok.com/@vmeetio"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="TikTok"
                        className="text-white/50 hover:text-[#C6A87C] transition-colors"
                      >
                        <FaTiktok size={20} />
                      </a>
          
                      <a
                        href="https://www.instagram.com/vmeetioest"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        className="text-white/50 hover:text-[#C6A87C] transition-colors"
                      >
                        <Instagram size={20} />
                      </a>
          
                      <a
                        href="https://www.facebook.com/profile.php?id=61590380737966"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        className="text-white/50 hover:text-[#C6A87C] transition-colors"
                      >
                        <Facebook size={20} />
                      </a>
                    </div>
        </div>

        {/* Platform links */}
        <div className="footerLinksCol">
          <p className="overline footerColHeading">Platform</p>
          <ul className="footerLinkList">
            <li>
              <Link to="/events" className="footerLink">
                Events
              </Link>
            </li>
            <li>
              <Link to="/lobby" className="footerLink">
                The Lobby
              </Link>
            </li>
            <li>
              <Link to="/host" className="footerLink">
                Host an event
              </Link>
            </li>
            <li>
              <Link to="/sponsor" className="footerLink">
                Sponsor a table
              </Link>
            </li>
            <li>
              <Link to="/sponsorship-calendar" className="footerLink">
                Sponsorship calendar
              </Link>
            </li>
            <li>
              <Link to="/sponsor-registry" className="footerLink">
                Sponsor registry
              </Link>
            </li>
            <li>
              <Link to="/network#apply-membership" className="footerLink">
                Membership
              </Link>
            </li>
            <li>
              <Link to="/moderators/apply" className="footerLink">
                Become a moderator
              </Link>
            </li>
            <li>
              <Link
                to="/retrieve"
                className="footerLink"
                data-testid="footer-retrieve"
              >
                Find my registration
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact column */}
        <div className="footerContactCol">
          <p className="overline footerColHeading">Contact</p>
          <p className="footerContactEmail">hello@vmeetio.io</p>
          <p className="footerCopyright">
            © {new Date().getFullYear()} vmeetio Society — Built for trusted
            conversations.
          </p>
        </div>
      </div>
    </footer>
  );
}
